export default __webpack_public_path__ + "static/media/clubhouse.f804be25.png";